import React from "react";
import { ContextMenuItem } from "../../../components/ui/context-menu";
import { DropdownMenuItem } from "../../../components/ui/dropdown-menu";
import { TooltipWrapper } from "../../../components/ui/tooltip-wrapper";

export interface MenuItemData {
	icon: React.ReactNode;
	label: string;
	onClick: () => void;
	disabled?: boolean;
	className?: string;
	show?: boolean;
	testId?: string;
	tooltip?: string;
}

export const SharedMenuItem: React.FC<{
	item: MenuItemData;
	asDropdown?: boolean;
	asContextMenu?: boolean;
	onClose?: () => void;
}> = ({ item, asDropdown = true, asContextMenu = false, onClose }) => {
	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		item.onClick();
		onClose?.();
	};

	if (item.show === false) return null;

	const content = (
		<>
			<div className="w-4 h-4 flex items-center justify-center">
				{item.icon}
			</div>
			<span>{item.label}</span>
		</>
	);

	const element = asContextMenu ? (
		<ContextMenuItem
			onClick={handleClick}
			disabled={item.disabled}
			aria-label={item.label}
			data-testid={item.testId}
			className={`grid grid-cols-[20px_1fr] gap-3 items-center ${
				item.className || ""
			}`}
		>
			{content}
		</ContextMenuItem>
	) : asDropdown ? (
		<DropdownMenuItem
			onClick={handleClick}
			disabled={item.disabled}
			aria-label={item.label}
			data-testid={item.testId}
			className={`grid grid-cols-[20px_1fr] gap-3 items-center ${
				item.className || ""
			}`}
		>
			{content}
		</DropdownMenuItem>
	) : (
		<button
			className={`relative cursor-default select-none rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground w-full disabled:opacity-50 disabled:pointer-events-none grid grid-cols-[20px_1fr] gap-3 items-center text-left ${
				item.className || ""
			}`}
			onClick={handleClick}
			disabled={item.disabled}
			aria-label={item.label}
			data-testid={item.testId}
		>
			{content}
		</button>
	);

	return item.tooltip ? (
		<TooltipWrapper title={item.tooltip} position="left">
			<div>{element}</div>
		</TooltipWrapper>
	) : (
		element
	);
};
